export function GetToken() {
    return localStorage.getItem("token");
}
